import React from 'react';
import Link from 'gatsby-link';
import classnames from 'classnames';

const Button = ({ children, primary, onClick, href, disabled, ...rest }) => {
  const classes = classnames('btn', { primary: primary });
  if (!href || disabled)
    return (
      <button
        className={classes}
        onClick={onClick}
        disabled={disabled}
        {...rest}
      >
        {children}
      </button>
    );
  return (
    <a className={classes} href={href} {...rest}>
      {children}
    </a>
  );
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/index.js